import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { LicenseInfo } from '@mui/x-license';

import { App } from 'src/compass/site/components';
import RingCentralCallback from 'src/compass/application/messaging/ringCentral/RingCentralCallback';
import { RINGCENTRAL_CALLBACK_PATH } from 'src/compass/application/messaging/ringCentral/ringCentralCallbackChannel';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

LicenseInfo.setLicenseKey('d64e3e02c411a5262ebcbf25e4dd50aaTz0xMjc1MTksRT0xODA2MTkxOTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');

// Local dev only: prefixes every tab title with the worktree name (e.g. "[Sub6] Home") so the
// several worktrees running side by side are distinguishable in the browser's tab bar. Pages set
// their own titles via Helmet (CasPage), so this has to be a titleTemplate on an ancestor Helmet --
// descendants inherit it -- rather than a one-off document.title assignment, which they'd overwrite.
const worktreeName = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_WORKTREE_NAME : '';

/*
  RingCentral's sign-in popup returns here. It gets only the page that hands the code back to the
  window that opened it - no router, no MSAL: a lapsed Microsoft login would otherwise send the
  popup off to sign in, holding RingCentral's single-use code. See ringCentralCallbackChannel.ts.
*/
if (window.location.pathname === RINGCENTRAL_CALLBACK_PATH) {
  root.render(<RingCentralCallback />);
} else {
  root.render(
    <HelmetProvider>
      {worktreeName && (
        <Helmet
          titleTemplate={`[${worktreeName}] %s`}
          defaultTitle={`[${worktreeName}] Compass Ag Solutions`}
        />
      )}
      <BrowserRouter>
        <Suspense>
          <App />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}
